import React, { Suspense } from 'react'
import useSWR from 'swr'
import logo from './logo.svg'
import storage from './storage'

import { Link, useHistory } from 'react-router-dom'

function Layout({ children }) {
  const { data: profile, revalidate } = useSWR('pxmusic_admin', storage)
  let history = useHistory()
  return (
    <div className="App">
      <header className="header">
        <div className="headerInner">
          <Link to="/" style={{ marginRight: 'auto' }} className="logo">
            <img src={logo} alt="logo" />
          </Link>

          {profile && (
            <div>
              {profile.superAdmin && (
                <Link to="/adminusers" className="navItem">
                  Admin Users
                </Link>
              )}
              <>
                <Link to="/templates" className="navItem">
                  Templates
                </Link>
                <span style={{ marginLeft: 22, marginRight: 22 }}>
                  {profile.name || profile.username}
                </span>
                <button
                  onClick={() => {
                    window.localStorage.removeItem('pxmusic_admin')
                    revalidate()
                    history.replace('/login')
                  }}
                  className="navItem"
                  style={{ marginLeft: 0, marginRight: 0 }}
                >
                  Logout
                </button>
              </>
            </div>
          )}
        </div>
      </header>
      <main className="main">
        <div className="mainInner">
          <Suspense
            fallback={
              <div className="home-grid">
                <h1 className="home-title" style={{ marginBottom: '1.3em' }}>
                  Loading…
                </h1>
              </div>
            }
          >
            <ErrorBoundary
              fallback={
                <div className="home-grid">
                  <h1 className="home-title" style={{ marginBottom: '1.3em' }}>
                    Ooops… something went wrong.
                  </h1>
                </div>
              }
            >
              {children}
            </ErrorBoundary>
          </Suspense>
        </div>
      </main>
    </div>
  )
}

export default Layout

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback
    }
    return this.props.children
  }
}
